// extracted by mini-css-extract-plugin
export var quantityInput = "_fp-0";